import { ICookieContext } from '@msdyn365-commerce/core-internal';

const SITE_GATE_COOKIE_NAME = 'gh-site-gate';

/**
 * Returns true if the site gate is not active, or if it is active and the user has entered the correct code.
 * @param siteGatePassword - The global app config password. If empty/undefined, the gate is not active.
 * @param cookies - The cookie context to check for the unlock cookie.
 */
export function isSiteGateUnlocked(siteGatePassword: string | undefined, cookies: ICookieContext): boolean {
    if (!siteGatePassword) {
        return true;
    }
    const cookie = cookies.get<string>(SITE_GATE_COOKIE_NAME);
    return cookie.status === 'FOUND' && cookie.value === '1';
}

export function getSiteGateCookieName(): string {
    return SITE_GATE_COOKIE_NAME;
}
